<template>
	<div>
		<div id="d21-query">
			<div class="d21-block">
				<div class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col">
						<div class="d21-close mdl-m--shown">
							<i class="material-icons" @click="close">cancel</i>
						</div>
						<Address v-if="Channel.Address" id="d21-query-header" />
					</div>
				</div>
				<template v-if="Channel.Content.DateInputHint && Channel.Content.DateInputHint.IsActive">
					<div class="mdl-grid">
						<div class="mdl-cell mdl-cell--12-col">
							<label class="text-header color-red hint" v-clean-html="V(Channel,'Content.DateInputHint.Text')"></label>
						</div>
					</div>
				</template>
				<div v-if="isShiftMode" class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col">
						<label class="text-header">
							{{ T("OneTicketing_What_would_you_like_to_book") }}
						</label>
						<d21-switcher ref="modes" :items="modes" @input="(item) => setMode(item)" :disabled="isSwitcherDisabled" @disabledClick="onDisabledClick" />
						<div v-if="isSwitcherDisabled && !isLoading" class="text-disabled text-small mt-2" :class="switcherDisabledClass">
							{{ T("ticketing_mode_switch_disabled_infotext") }}
						</div>
					</div>
				</div>
				<div v-if="Channel.Mode === 'Dates' || selectedMode === 'Dates'" class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col">
						<label v-if="isEvent" class="text-header">
							{{ T("OneTicketing_Which_Event") }}
						</label>
						<label v-else-if="Channel.Mode === 'Dates'" class="text-header">
							{{ T("OneTicketing_Which_Game") }}
						</label>
						<div id="d21-query-events" class="w-100">
							<Events ref="events" :selected-mode="selectedMode" />
						</div>
					</div>
				</div>
				<div v-else class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col">
						<template v-if="selectedMode !== 'Seasonal' && selectedMode !=='Multi'">
							<label class="text-header" :class="{'text-header--small': Channel.Mode === 'ShiftsOrDates'}">
								{{ T("OneTicketing_When_would_you_like_to_visit") }}
							</label>
							<div class="mdl-cell mdl-cell--12-col">
								<div class="d21-presset-inline">
									<div class="d21-date-wrapper">
										<datepicker id="date-from" v-model="Reservation.Query.From.Date" @input="setDays('from')" :noClearButton="true" :no-label="true" :no-button-now="true" :range="false" :only-date="true" :min-date="minDateFrom" :no-header="false" :no-shortcuts="true" :label="'Bitte Datum wählen'" :color="'#006bb7'" :formatted="'ll'" :output-format="'YYYY-MM-DD'" :auto-close="true"></datepicker><i class="d21-calendar-icon material-icons">today</i>
									</div>
								</div>
								<div class="d21-presset-days">
									<label>{{ T("quickselect") + ":" }}</label>
									<div class="active">
										<span ref="today" data-group="from" data-set="today" @click="setDate">{{ T("today") }}</span>
									</div>
									<div>
										<span ref="tomorrow" data-set="tomorrow" data-group="from" @click="setDate">{{ T("tomorrow") }}</span>
									</div>
									<div>
										<span ref="dayaftertomorrow" data-set="dayaftertomorrow" data-group="from" @click="setDate">{{ T("day_after_tomorrow") }}</span>
									</div>
								</div>
							</div>
						</template>
						<template v-if="showTimeFrameSlider">
							<div id="d21-query-shifts">
								<vueper-slides :touchable="isMobile" ref="timeFrames" @slide="setSliderTimeFrame($event.currentSlide.index)" @ready="onSlidesReady" :breakpoints="breakpoints" class="no-shadow" :bullets="false" fixed-height="40px" :dragging-distance="70" :disable="isLoading">
									<template v-slot:arrow-left>
										<i class="material-icons">navigate_before</i>
									</template>
									<template v-slot:arrow-right>
										<i class="material-icons">navigate_next</i>
									</template>
									<vueper-slide v-for="(timeFrame, i) in timeFrames" :key="i" :title="timeFrame.fullText" @click.native="$refs.timeFrames.goToSlide(i)" :class="{ disabled: checkDisabled(timeFrame) }" />
								</vueper-slides>
							</div>
						</template>
						<Loader>
							<ProductList v-if="hasSearchResult" />
						</Loader>
					</div>
				</div>
			</div>
		</div>

		<BottomNav @next="next" :hiddenText="buttonHiddenText" :shownText="buttonShownText" isValid isNextButtonActive>
			<!-- <div class="d21-language-select">
				<d21-select :list="this.languages"></d21-select>
			</div> -->
			<div class="mdl-m--hidden" :style="$route.query && $route.query.referrer && !isMobile ? 'display:block' : 'display:none'">
				<button class="btn btn-primary" @click="close">
					<span>{{ T("cancel") }}</span>
				</button>
			</div>

			<ShoppingCart ref="shoppingCart" v-if="Channel.Settings.HasShoppingCart" @add="onAddToShoppingCart" :modalWidth="modalWidth" />
			<div class="d21-sum d-none d-block-sm">
				<template v-if="totalSum > 0 && !isLoading">
					{{ T("total") + ": " + formatPrice(totalSum) }}
				</template>
			</div>
		</BottomNav>

		<Modal name="query.validation" :title="T('info')" :actions="validationModalActions">
			<div class="mdl-grid">
				<span v-for="(error, index) in validationResult.validationErrors" :key="index" class="error">
					{{ error }}
				</span>
			</div>
		</Modal>
	</div>
</template>

<script>
	import ShoppingCart from "./shopping-cart.vue";
	import Events from "./events";
	import moment from "moment";
	import baseMixin from "../mixins/base";
	import Datepicker from "vue-ctk-date-time-picker";
	import ProductList from "./partial/product-list.vue";
	import Address from "./partial/address.vue";
	import Loader from "./ui/loader.vue";
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import {
		VueperSlides,
		VueperSlide
	} from "vueperslides";
	import "vueperslides/dist/vueperslides.css";
	import {
		extend
	} from "vee-validate";
	import {
		required,
		between
	} from "vee-validate/dist/rules";
	import BottomNav from "./ui/bottom-nav.vue";
	import {
		mapActions,
		mapGetters,
		mapState
	} from "vuex";
	import helpers from "../scripts/_helpers";
	import Modal from './modal.vue'

	export default {
		mixins: [baseMixin],
		components: {
			Datepicker,
			VueperSlide,
			VueperSlides,
			ShoppingCart,
			BottomNav,
			Events,
			ProductList,
			Address,
			Loader,
			Modal,
		},
		name: "d21-query",
		data() {
			return {
				searchTimeout: null,
				hasSearchResult: false,
				minDateFrom: moment().format("YYYY-MM-DD"),
				minDateUntil: moment().add(1, "day").format("YYYY-MM-DD"),
				selectedEvent: null,
				selectedEventModal: null,
				dates: {
					hours: [],
					minutes: [],
				},
				selectedMode: null,
				selectedTimeSlot: {
					product: null,
					tariff: null,
				},
				isLoading: false,
				switcherDisabledClass: "",
				showValidationModal: false,
			};
		},
		computed: {
			isShiftMode() {
				return ["Shifts", "ShiftsOrDates"].includes(this.Channel.Mode);
			},
			validationModalActions() {
				return [{
					text: "Ok",
					onClick: () => {
						this.$modals.hide("query.validation");
					},
					isPrimary: true,
				}, ];
			},
			...mapGetters(["canCheckout"]),
			...mapState(["validationResult"]),
			showTimeFrameSlider() {
				return this.Channel.Mode !== "AlwaysAvailableProducts" &&
						this.timeFrames.length > 0 &&
                        !this.isMultiOrSeasonal;
			},
			isSwitcherDisabled() {
				return this.isLoading || this.Reservation.MultiDate.IsActive;
			},
			isEvent() {
				const oids = [122329, 123056, 123072, 123198];
				return this.Channel.Mode === "Dates" && oids.includes(this.Channel._oid);
			},
			breakpoints() {
				return {
					4000: {
						slideRatio: 1 / 5,
						visibleSlides: this.timeFrames.length >= 5 ? 5 : this.timeFrames.length,
						arrows: false,
						style: "background-color: red",
					},
					900: {
						slideRatio: 1 / 4,
						visibleSlides: this.timeFrames.length >= 3 ? 3 : this.timeFrames.length,
						arrows: true,
					},
				};
			},
			modalWidth() {
				return this.isMobile ? "90%" : "900";
			},
			checkAlternatives() {
				return (
					this.Reservation &&
					(this.Reservation.Info.Capacity.Status == "Orange" ||
						this.Reservation.Info.Capacity.Status == "Red" ||
						this.Reservation.Info.Capacity.AllUnavailable)
				);
			},
			timeFrames() {
				if (!this.Channel || !this.Reservation.From.TimeFrame) return [];
				//
				const timeFrames = this.Channel.TimeFrames.map((t) => {
					const isSelected = t._uuid === this.Reservation.From.TimeFrame._uuid;
					return this.asTimeFrameViewModel(
						t,
						isSelected,
						this.Channel.TimeFrames.length
					);
				});

				// sort
				timeFrames.sort((x, y) => {
					return x.position - y.position;
				});

				//
				return timeFrames;
			},
			eventsList() {
				return this.isMultiOrSeasonal ?
					this.alwaysAvailableProducts :
					this.defaultEvents;
			},
			defaultEvents() {
				return this.getProductsList((p) => p.Type !== "AlwaysAvailableProduct");
			},
			alwaysAvailableProducts() {
				return this.getProductsList(
					(p) =>
					p.Type === "AlwaysAvailableProduct" ||
					p.Type === "Multi" ||
					p.Type === "Season"
				);
			},
			multiAvailableProducts() {
				return this.getProductsList((p) => p.Type === "Multi");
			},
			SeasonalAvailableProducts() {
				return this.getProductsList((p) => p.Type === "Season" || p.Type === "AlwaysAvailableProduct");
			},
			isMultiOrSeasonal(){
					return ['Multi', 'Seasonal'].includes(this.selectedMode);
			},
			modeOptions(){
					return [
					{
						condition: this.Channel.Dates.some(c => c.Type === "Ticket"),
						value: "Shifts",
						text: "Tickets",
						selectedKey: "tickets"
					},
					{
						condition: this.SeasonalAvailableProducts.groups.length > 0,
						value: "Seasonal",
						text: "Season_tickets",
						selectedKey: "season-tickets"
					},
					{
						condition: this.multiAvailableProducts.groups.length > 0,
						value: "Multi",
						text: "Multi_tickets",
						selectedKey: "multi-tickets"
					},
					{
						condition: this.Channel.Dates.some(c => c.Type === "SimpleEvent" || c.Type === "RecurrentEvent"),
						value: "Dates",
						text: "Events",
						selectedKey: "events"
					}
				];
			},
			modes() {
				const items = [];
				this.modeOptions.forEach(opt => {
					if (opt.condition) {
						items.push({
							value: opt.value,
							text: this.T(opt.text),
							subText: null,
							isSelected: this.Channel.DepartmentOrProduct === opt.selectedKey
						});
					}
				});

				return items;
			},
			buttonHiddenText() {
				return this.T("go_to_address_input");
			},
			buttonShownText() {
				return this.T("proceed");
			},
		},
		created() {
			EventBus.$on("loading_start", () => {
				this.isLoading = true;
			});

			EventBus.$on("loading_end", () => {
				this.isLoading = false;
			});

			EventBus.$on("next", () => {
				this.next();
			});

			//
			for (let i = 0; i <= 23; i++) {
				this.dates.hours.push({
					text: i.pad(2),
					value: i,
				});
			}
			for (let i = 0; i < 60; i += 5) {
				this.dates.minutes.push({
					text: i.pad(2),
					value: i,
				});
			}
		},
		mounted() {
			this.start();
			if (!this.$root.hub.app.isStarted) {
				//
				moment.locale("de-DE");

				//
				extend("required", {
					...required,
					key: "{_field_}",
					message: (key) => {
						return `${this.T("OneTicketing_Please_Enter_start")} ${this.T(
            key
          )} ${this.T("OneTicketing_Please_Enter_end")}`;
					},
				});
				extend("requiredCb", {
					validate: (value) => {
						return value;
					},
					key: "{_field_}",
					message: (key) => {
						return `${this.T("OneTicketing_Please_Accept")} ${this.T(key)}.`;
					},
				});
				extend("between", {
					...between,
					min: "{min}",
					max: "{max}",
					message: (min, max) => {
						return `${this.T("OneTicketing_Age_between_start")} ${min} ${this.T(
            "and"
          )} ${max} ${this.T("OneTicketing_Age_between_end")}`;
					},
				});
				extend("emailConfirm", {
					params: ["target"],
					validate(value, {
						target
					}) {
						return value === null || value === target;
					},
					message: () => {
						return `${this.T("OneTicketing_Email_Confirmation_does_not_match")}`;
					},
				});

				//
				this.$root.hub.app.isStarted = true;
			} else {
				// default
				if (
					this.Reservation.Mode === null &&
					this.Channel.Mode === "ShiftsOrDates"
				) {
					this.selectedMode = "Shifts";
				} else if (this.Reservation.Mode !== null) {
					var selectedMode = this.modes.find(
						(s) => s.value === this.Reservation.Mode
					);
					selectedMode.isSelected = true;
					if (this.$refs.modes) this.$refs.modes.select(selectedMode);
				}

				//
				this.selectedMode = this.Reservation.Mode;
				if (
					(this.selectedMode === "Dates" ||
						this.isMultiOrSeasonal) &&
					this.Reservation.From.Event !== null
				) {
					this.eventsList.groups.forEach((g) =>
						g.events.forEach((e) => {
							if (
								e._uuid === this.Reservation.From.Event &&
								moment(e.Date, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm") ===
								this.Reservation.Query.From.Date.format("YYYY-MM-DD HH:mm")
							) {
								e.isSelected = true;
								this.selectedEvent = e;
							}
						})
					);

					if (this.selectedEvent !== null)
						this.eventSelected(this.selectedEvent, true);
				}

				//
				this.selectShiftOrEvent();
			}

			const opt = this.modeOptions.find(o => o.selectedKey === this.Channel.DepartmentOrProduct);
			if (opt) {
				const {value, text} = opt;
				this.setMode({
					value,
					text,
					subText: null,
					isSelected: true
				});
			}
		},
		methods: {
			...mapActions(["validateReservation"]),
			cssClass(tariff) {
				var cssClass = "d21-query-products-item";
				if (!tariff.IsValid) cssClass += " d21-query-products-item--unavailable";
				if (
					this.Reservation.Discounts.length > 0 &&
					this.Reservation.Discounts[0].isSelected
				)
					cssClass += " d21-query-products-item--discounted";
				return cssClass;
			},
			checkDisabled(timeFrame) {
				const date = moment(this.Reservation.Query.From.Date);
				const tf = this.Channel.TimeFrames.find(
					(c) => c._uuid === timeFrame.value
				);

				const timeAndDate = date.add(tf.Times.End, "minutes");

				// if shift end has passed -> disabled
				return moment() > timeAndDate;
			},
			eventSelected(event, executeSearch) {
				if (this.selectedEvent === null || this.selectedEvent.key !== event.key) {
					this.selectedEvent = event;
					this.Reservation.Query.From.Date = moment(
						event.Date,
						"YYYY-MM-DD HH:mm"
					);
					this.Reservation.Query.From.StartTime = event.StartTime;
					this.Reservation.EventDate = event;
					this.Reservation.From.Event = event._uuid;
					this.Reservation.From.StartTime = event.StartTime;
					this.Reservation.From.EndTime = event.EndTime;
					this.Reservation.Mode = "Dates";
					this.Reservation.From.TimeFrame = null;
					if (executeSearch) this.search();
				}
			},
			timeSlotCssClass(product, tariff) {
				const capacity = product.Capacity;
				let cssClasses = "";

				// by capacity
				if (capacity == 0) cssClasses += "red";
				else if (capacity < 2) cssClasses += "orange";
				else cssClasses += "green";

				// by selection
				if (this.selectedTimeSlot.tariff == tariff) cssClasses += " selected";

				//
				return cssClasses;
			},
			getProductsList(predicate) {
				//
				var eventsList = {
					isGrouped: true,
					groups: [],
				};

				//
				if (!this.Channel || !this.Channel.Dates) return eventsList;

				// group events by _uuid (for recurrent events)
				const groupBy = function (arr, f) {
					return arr.reduce((out, val) => {
						let by = typeof f === "function" ? "" + f(val) : val[f];
						(out[by] = out[by] || []).push(val);
						return out;
					}, {});
				};

				//
				var filtered = this.Channel.Dates.filter(predicate);
				var grouped = groupBy(filtered, (d) => d._uuid);

				//
				for (const key in grouped) {
					var group = grouped[key];
					group.forEach((item, itemX) => {
						item.isSelected = false;
						item.key = `event_${eventsList.groups.length}_${itemX}`;
					});
					eventsList.groups.push({
						key: key,
						Content: {
							Name: group[0].Content.Name,
							Locality: group[0].Content.Locality,
							Notes: group[0].Content.Notes,
						},
						events: group,
					});
				}

				//
				return eventsList;
			},
			checkDates() {
				//
				this.minDateReturn = moment(this.Reservation.Query.From.Date)
					.add(1, "day")
					.format("YYYY-MM-DD");
			},
			setSliderTimeFrame(selectedIndex) {
				const timeFrame = this.timeFrames[selectedIndex];
				this.setTimeFrame(timeFrame);
			},
			setMode(selectedItem) {
				if (selectedItem.value !== this.selectedMode) {
					this.selectedMode = selectedItem.value;
					this.Reservation.Query.From.StartTime = null;
					this.Reservation.Query.From.EndTime = null;
					this.Reservation.EventDate = null;
					this.Reservation.From.Event = null;
					this.Reservation.From.StartTime = null;
					this.Reservation.From.EndTime = null;
					this.Reservation.From.TimeFrame = null;
					this.Reservation.From.Date = null;
					this.Reservation.Query.From.Date = null;
					this.setReservationDefaults();
				}
				this.selectedEvent = null;
				this.Reservation.Mode = selectedItem.value;

				if (this.isMultiOrSeasonal) {
					// just use today for Seasonal products
					this.Reservation.Query.From.Date = moment().format("YYYY-MM-DD");
					this.Reservation.From.Date = moment().format("YYYY-MM-DD");
					// set timeframe to null for seasonal products, because there could be multiple seasonal products with multiple timeframes.
					this.Reservation.From.TimeFrame = null;
				}

				if (
					this.selectedMode === "Dates" &&
					this.Reservation.EventDate === null &&
					this.Channel.Dates &&
					this.Channel.Dates.length === 1
				) {
					this.eventSelected(this.Channel.Dates[0], true);
				} else if (this.selectedMode === "Dates" && this.selectedEvent === null) {
					this.hasSearchResult = false;
				}

				this.activateMode(selectedItem.value);
			},
			activateMode(value){
				const opt  = this.modeOptions.find(m => m.value === value );
				if (opt) {
					const { selectedKey } = opt;
					helpers.fn.pushWindowHistoryState(selectedKey);
					this.$route.params.departmentOrProduct = selectedKey;
					this.Channel.DepartmentOrProduct = selectedKey;
				} else {
					helpers.fn.clearLastURLUpdate();
				}
			},
			setTimeFrame(selectedItem) {
				if (this.Channel.TimeFrames)
					this.Reservation.From.TimeFrame = this.Channel.TimeFrames.find(
						(t) => t._uuid === selectedItem.value
					);
			},
			start() {
				this.setDefaults();
			},
			setReservationDefaults() {
				//
				let routeQuery = this.$route.query;

				// depart date
				let fromDate = moment();
				if (routeQuery.from_date)
					fromDate = moment(routeQuery.from_date, "YYYY-MM-DD");

				this.Reservation.Query.From.Date = fromDate.format("YYYY-MM-DD");
				this.Reservation.Query.From.Tick = fromDate;
				this.Reservation.Query.From.Hour = fromDate.hour();
				this.Reservation.Query.From.Minute = fromDate.minutes();
			},
			setDefaults() {
				//
				let routeQuery = this.$route.query;

				// default payment
				this.Reservation.Payment.Method = this.Channel.Payment.Methods[0];

				// adress data
				if (routeQuery.givenname)
					this.Reservation.Customer.Givenname = routeQuery.givenname;
				if (routeQuery.lastname)
					this.Reservation.Customer.Lastname = routeQuery.lastname;
				if (routeQuery.email)
					this.Reservation.Customer.Communication.Email = routeQuery.email;

				//
				this.setReservationDefaults();

				//
				this.selectedMode = this.Reservation.Mode;
				this.setDays();
				this.search();
			},
			getValidTimeFrames(date) {
				return this.Channel.AllPeriods.filter((p) => p.Type === "Shifts")
					.filter((p) => this.isValidPeriod(p, date))
					.map((c) => c.TimeFrames)
					.flat()
					.filter((t) => this.isValidTimeFrame(t, date));
			},
			selectShiftOrEvent() {
				if (this.Channel.Mode === "Dates") {
					if (this.Channel.Dates.length === 1)
						this.eventSelected(this.Channel.Dates[0], false);
					return;
				}
				// filter shifts by weekdays
				var date = moment(this.Reservation.Query.From.Date, "YYYY-MM-DD HH:mm");

				this.Channel.TimeFrames = this.getValidTimeFrames(date);

				let shouldResetTimeFrame;

				// the this.Reservation.From.Shift.Type is set to "Morning" when there is no valid shift for this date
				// if the customer has no Morning shift, this can cause some problems, like no availability
				if (this.Reservation.From.TimeFrame) {
					shouldResetTimeFrame = this.Channel.AllPeriods.map((c) => c.TimeFrames)
						.flat()
						.some((elem) => elem._uuid !== this.Reservation.From.TimeFrame._uuid);
				}

				// reset because of shift change?
				let selectedTimeFrame_uuid = null;
				if (
					(this.Reservation.From.TimeFrame &&
						this.Reservation.From.TimeFrame.WeekDays) ||
					shouldResetTimeFrame
				) {
					selectedTimeFrame_uuid = this.Reservation.From.TimeFrame._uuid;
					this.Reservation.From.TimeFrame = null;
				}

				// default shift
				if (this.Reservation.From.TimeFrame === null) {
					//
					let routeQuery = this.$route.query;
					let selectedTimeFrame = null;

					//
					const totalMinutes = moment().diff(moment().startOf("day"), "minutes");

					if (selectedTimeFrame_uuid)
						selectedTimeFrame = this.Channel.TimeFrames.find(
							(t) => t._uuid == selectedTimeFrame_uuid
						);
					if (!selectedTimeFrame && routeQuery.shift_type)
						selectedTimeFrame = this.Channel.TimeFrames.find(
							(t) => t.Name === routeQuery.shift_type
						);
					if (!selectedTimeFrame)
						selectedTimeFrame = this.Channel.TimeFrames.find(
							(t) => t.Times.Start <= totalMinutes && t.Times.End >= totalMinutes
						);
					if (!selectedTimeFrame)
						selectedTimeFrame = this.Channel.TimeFrames.find(
							(t) => t.Times.Start >= totalMinutes
						);
					if (!selectedTimeFrame) selectedTimeFrame = this.Channel.TimeFrames[0];

					// TODO: What to do here? should display an error here.
					// if (!selectedTimeFrame) selectedTimeFrame = {
					// 	Type: "Morning",
					// 	DaysOfWeek: [dayOfWeek]
					// };
					if (!selectedTimeFrame) return;

					selectedTimeFrame.isSelected = true;
					this.Reservation.From.TimeFrame = selectedTimeFrame;
				}
			},
			onSlidesReady() {
				this.handleInitialTimeFrame();
			},
			findSelectedTimeFrameInSlider() {
				if (this.$refs.timeFrames && this.$refs.timeFrames.goToSlide) {
					const selectedTimeFrame = this.timeFrames.find((t) => t.isSelected);
					if (selectedTimeFrame) {
						const selectedTimeFrameIndex =
							this.timeFrames.indexOf(selectedTimeFrame);
						if (selectedTimeFrameIndex > -1) {
							this.$refs.timeFrames.goToSlide(selectedTimeFrameIndex);
						}
					}
				}
			},
			selectTimeSlot(product, tariff) {
				if (tariff.Capacity <= 0) return;
				if (this.selectedTimeSlot.tariff) {
					this.selectedTimeSlot.tariff.Count = 0;
					this.selectedTimeSlot.tariff.isSelected = false;
				}
				this.selectedTimeSlot.product = product;
				this.selectedTimeSlot.tariff = tariff;
				this.selectedTimeSlot.tariff.Count = 1;
				this.selectedTimeSlot.tariff.isSelected = true;
			},
			isValidPeriod(period, date) {
				return (
					(!period.From || moment(period.From) <= date) &&
					(!period.Until || date <= moment(period.Until))
				);
			},
			isValidTimeFrame(timeFrame, date) {
				let dayOfWeek = [
					"Sunday",
					"Monday",
					"Tuesday",
					"Wednesday",
					"Thursday",
					"Friday",
					"Saturday",
				][date.day()];
				return timeFrame.WeekDays.includes(dayOfWeek);
			},
			setDate(e) {
				let group = e.target.dataset.group;
				let set = e.target.dataset.set;

				//
				if (group == "from") {
					if (set == "today")
						this.Reservation.Query.From.Date = moment().format("YYYY-MM-DD");
					if (set == "tomorrow")
						this.Reservation.Query.From.Date = moment()
						.add(1, "days")
						.format("YYYY-MM-DD");
					if (set == "dayaftertomorrow")
						this.Reservation.Query.From.Date = moment()
						.add(2, "days")
						.format("YYYY-MM-DD");
				}

				// check min date
				this.setDays(group);
			},
			setDays(group) {
				//
				this.setGroupInactive("from");

				// check dates
				this.checkDates();

				// is today / tomorrow / aftertomorrow?
				if (this.Channel.Mode !== "Dates") {
					let fromDate = moment(this.Reservation.Query.From.Date).format(
						"YYYY-MM-DD"
					);
					if (this.$refs.today && fromDate == moment().format("YYYY-MM-DD"))
						this.$refs.today.parentNode.classList.add("active");
					else if (
						this.$refs.tomorrow &&
						fromDate == moment().add(1, "days").format("YYYY-MM-DD")
					)
						this.$refs.tomorrow.parentNode.classList.add("active");
					else if (
						this.$refs.dayaftertomorrow &&
						fromDate == moment().add(2, "days").format("YYYY-MM-DD")
					)
						this.$refs.dayaftertomorrow.parentNode.classList.add("active");
				}

				//
				this.selectShiftOrEvent();
				this.search();
			},
			setGroupInactive(group) {
				let items = document.querySelectorAll("[data-group=" + group + "]");

				for (let i = 0; i < items.length; i++) {
					items[i].parentNode.classList.remove("active");
				}
			},
			jumpTo(selector) {
				document.querySelector("#" + selector).scrollIntoView({
					behavior: "smooth",
				});
			},
			search() {
				// handled in "Events" component
				if (this.selectedMode === "Dates") return;
				if (this.searchTimeout !== null) window.clearTimeout(this.searchTimeout);
				this.searchTimeout = window.setTimeout(() => {
					EventBus.$emit("loading_start");

					this.Reservation.Info.Capacity.AllUnavailable = false;
					this.Reservation.Alternatives = [];
					this.Reservation.Products = [];
					this.Reservation.Discounts = [];

					let from = this.Reservation.Query.From.Date.format("YYYY-MM-DD");
					let until = moment(this.Reservation.Query.From.Date)
						.add(1, "days")
						.format("YYYY-MM-DD");
					let dateParameter = this.isMultiOrSeasonal || !this.Reservation.From.TimeFrame ? null : `timeframe_uuid=${this.Reservation.From.TimeFrame._uuid}`;
					let command = this.isMultiOrSeasonal  ?
						`/availability/seasonal?from=${from}&until=${until}&type=${this.selectedMode}&productsVersionCode=display_name` :
						`/availability/tickets?from=${from}&until=${until}&${dateParameter}&productsVersionCode=display_name`;

					this.apiRequest(command, null, "GET", (response) => {
						if (response.Value) {
							if (response.Value.Discounts) {
								response.Value.Discounts.forEach((d) => {
									d.isSelected = false;
									d.errorMessage = "";
								});
							} else {
								response.Value.Discounts = [];
							}

							// set defaults
							this.Reservation.Info = response.Value.Info;

							//
							response.Value.Result.forEach((r) => {
								r.Tariffs.forEach((t) => {
									const tariff = this.Reservation.fn.getTariff(t.Tariff);
									t.Units = [];
									t.NumberOfPersons =
										tariff.Restrictions &&
										tariff.Restrictions.Occupancy &&
										tariff.Restrictions.Occupancy.Min ?
										tariff.Restrictions.Occupancy.Min :
										1;
									t.Occupancy = [];
								});
								r.Occupancy = [];
							});

							this.Reservation.Products = response.Value.Result;
							this.Reservation.Discounts = response.Value.Discounts;

							// check alternatives?
							if (
								this.Channel.Alternatives &&
								this.Channel.Alternatives.length > 0 &&
								this.checkAlternatives
							) {
								let alternativeCommand = `/availability/alternatives?from=${from}&until=${until}&${dateParameter}`;
								this.apiRequest(alternativeCommand, null, "GET", (response) => {
									if (response.Value)
										this.Reservation.Alternatives = response.Value.Items;
									EventBus.$emit("loading_end");
									this.hasSearchResult = true;
								});
							} else {
								EventBus.$emit("loading_end");
								this.hasSearchResult = true;
							}
						} else {
							this.Reservation.Info = null;
							this.Reservation.Products = [];
							this.Reservation.Discounts = [];
							EventBus.$emit("loading_end");
							this.hasSearchResult = true;
						}
					});
				}, 100);
			},
			round5(x) {
				return x % 5 >= 2.5 ? parseInt(x / 5) * 5 + 5 : parseInt(x / 5) * 5;
			},
			next() {
				// add remaining selected products that have not been explicitly added to shopping cart.
				if (this.Reservation.MultiDate.IsActive && this.$refs.shoppingCart) {
					this.$refs.shoppingCart.addToShoppingCart();
					// reset tariffs
					this.Reservation.Products.map((c) => c.Tariffs)
						.flat()
						.filter((c) => c.Count > 0)
						.forEach((c) => (c.Count = 0));
				}

				this.validateReservation();

				if (!this.canCheckout) {
					this.$modals.show("query.validation");
					return;
				}

				this.$router.push({
					name: "checkout",
				});
			},
			onAddToShoppingCart() {
				this.hub.ui.notificationCenter.success({
					title: "product_added_to_cart",
					relativeTo: ".d21-shoppingCart-icon",
				});
				if (this.selectedMode === "Dates") {
					this.$refs.events.search();
				} else {
					this.search();
				}
			},
			close() {
				parent.postMessage({
						type: "d21-close-overlay",
					},
					"*"
				);
			},
			handleInitialTimeFrame() {
				// check if timeframe is in past
				if (!moment(this.Reservation.Query.From.Date).isSame(moment(), "day"))
					return;

				if (
					this.selectedTimeFrame &&
					this.checkDisabled(this.selectedTimeFrame)
				) {
					this.timeFrames.forEach((t) => (t.isSelected = false));

					// find first timeframe that is not disabled
					const tf = this.timeFrames.find((t) => !this.checkDisabled(t));
					if (tf) tf.isSelected = true;
				}

				this.findSelectedTimeFrameInSlider();
			},
			onDisabledClick() {
				this.switcherDisabledClass = "shake";

				setTimeout(() => {
					this.switcherDisabledClass = "";
				}, 1000);
			},
		},
		watch: {
			"Reservation.From.TimeFrame": {
				handler(newValue, oldValue) {
					if (newValue === oldValue) return;
					this.search();
				},
			},
			"Reservation.Query.From.Date": {
				handler(newValue, oldValue) {
					if (this.selectedMode === "Dates") return;
					this.handleInitialTimeFrame();
				},
			},
			selectedMode(newValue) {
				if ((newValue === "Shifts" || newValue === "Ticket") && this.Reservation.From.TimeFrame === null)
					this.selectShiftOrEvent();
				this.search();
			},
			'modes'(newValue) {
				console.log("modes updated", JSON.stringify(newValue));
			}
		},
	};
</script>